import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import RealEstate from "@/pages/RealEstate";
import Interiors from "@/pages/Interiors";
import Furniture from "@/pages/Furniture";
import Experience from "@/pages/Experience";
import Contact from "@/pages/Contact";
import AirConditioning from "@/pages/AirConditioning";

const ScrollManager = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        const lenis = window.__lenis;
        if (hash) {
            const el = document.getElementById(hash.slice(1));
            if (el) {
                if (lenis) lenis.scrollTo(el, { offset: -96 });
                else el.scrollIntoView();
                return;
            }
        }
        if (lenis) lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
    }, [pathname, hash]);
    return null;
};

function App() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const lenis = new Lenis({ lerp: 0.09 });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="App bg-cream text-ink font-sans antialiased">
            <BrowserRouter>
                <ScrollManager />
                <Header />
                <main id="main-content">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/real-estate" element={<RealEstate />} />
                        <Route path="/interiors" element={<Interiors />} />
                        <Route path="/furniture" element={<Furniture />} />
                        <Route path="/air-conditioning" element={<AirConditioning />} />
                        <Route path="/experience" element={<Experience />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </main>
                <Footer />
            </BrowserRouter>
        </div>
    );
}

export default App;
